import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare, faCheckSquare } from '@fortawesome/fontawesome-free-regular'

class Checkbox extends Component {
  state = {
    hover: false
  }

  render() {
    const { hover } = this.state
    const {
      onClick,
      selected,
      color = '#289e64',
      hoverColor = '#61d092',
      style,
      placeholder
    } = this.props

    return (
      <a
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => onClick()}
        style={{
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          ...style
        }}
      >
        <FontAwesomeIcon
          icon={selected ? faCheckSquare : faSquare}
          style={{ fontSize: 26, color: hover ? hoverColor : color }}
        />
        <p style={{ marginLeft: 25 }}>{placeholder}</p>
      </a>
    )
  }
}

export { Checkbox }



// WEBPACK FOOTER //
// ./src/components/common/Checkbox.js